module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/index/index.component.css
// module id = ./src/app/index/index.component.css
// module chunks = main